<template>
  <div>
    <div class="tab-pane-body-video">
      <div class="body-header">
        <el-button size="medium" type="warning" icon="iconfont icon-tianjiacaidan1"  @click="addVideoChapter" v-if="userPermissions.indexOf('course_video') != -1">添加章节</el-button>
      </div>
      <div class="body-content">
        <el-tree
          :data="videoChapterList"
          node-key="unique_key"
          :highlight-current="true"
          :expand-on-click-node="false"
          default-expand-all
          draggable
          :allow-drop="handleAllowDrop"
          @node-drop="handleNodeDrop">
          <div class="video-tree-node" slot-scope="{node,data}">
            <div class="chapter-node" v-if="data.data_type=='chapter'">
              <span>第{{data.identify_key}}章</span> 
              <span>{{data.title}}</span>
              <div class="right">
                <ApeButton name="添加视频" type="primary" size="mini" icon="icon-zengjiazicaidan" permission="course_video" @click="addVideo(data.id)"></ApeButton>
                <ApeButton name="编辑" type="primary" size="mini" icon="el-icon-edit" permission="course_video" @click="editVideoChapter(data.id)"></ApeButton>
                <el-popover
                  placement="top"
                  width="150"
                  v-model="data.visible">
                  <p>确定要删除记录吗？</p>
                  <div style="text-align: right; margin: 0;">
                    <el-button type="text" size="mini" @click="data.visible=false">取消</el-button>
                    <el-button type="danger" size="mini" @click="deleteVideoChapter(data)">确定</el-button>
                  </div>
                  <ApeButton slot="reference" name="删除" type="danger" size="mini" icon="el-icon-delete" permission="course_video"></ApeButton>
                </el-popover>
              </div>
            </div>
            <div class="video-node" v-if="data.data_type=='video'">
              <span class="video-identify">{{data.identify_key}}</span>
              <span>{{data.title}}</span>
              <span v-if="data.status" class="success-status-tag">转码完成</span>
              <span v-else class="warning-status-tag">转码中</span>
              <div class="right">
                <ApeButton v-if="data.status" name="预览" type="success" size="mini" icon="icon-shipin2" permission="course_video" @click="videoPreview(data)"></ApeButton>
                <ApeButton name="编辑" type="primary" size="mini" icon="el-icon-edit" permission="course_video" @click="editVideo(data.id)"></ApeButton>
                <el-popover
                  placement="top"
                  width="150"
                  v-model="data.visible">
                  <p>确定要删除记录吗？</p>
                  <div style="text-align: right; margin: 0;">
                    <el-button type="text" size="mini" @click="data.visible=false">取消</el-button>
                    <el-button type="danger" size="mini" @click="deleteVideo(data)">确定</el-button>
                  </div>
                  <ApeButton slot="reference" name="删除" type="danger" size="mini" icon="el-icon-delete" permission="course_video"></ApeButton>
                </el-popover>
              </div>
              <div class="quick-actions" v-if="userPermissions.indexOf('course_video') != -1">
                <span>试看规则：</span>
                <el-switch
                  v-model="data.is_try"
                  active-color="#1890ff"
                  :active-value="1"
                  :inactive-value="0"
                  @change="changeTry(data)">
                </el-switch>
                <el-tooltip content="默认0秒，完整试看！" placement="top" v-if="data.is_try == 1">
                  <span class="try-time">
                    <span>可试看：</span>
                    <el-input-number v-model="data.try_time" size="small" controls-position="right" :step="60" :min="0" :max="7200" @change="changeTryTime(data)"></el-input-number>
                    <span> 秒！</span>
                  </span>
                </el-tooltip>
              </div>
            </div>
          </div>
        </el-tree>
      </div>
    </div>
    <ModalDialog :dialogData="dialogData" @dialogConfirm="dialogConfirm" @dialogClose="dialogClose">
      <template slot="content">
        <el-form :model="videoChapterFormData" :rules="videoChapterRules" ref="videoChapterForm" label-position="right" label-width="96px">
          <el-form-item label="章节标题" prop="title">
            <el-input v-model="videoChapterFormData.title"></el-input>
          </el-form-item>
          <el-form-item label="简介" prop="intro">
            <el-input type="textarea" v-model="videoChapterFormData.intro"></el-input>
          </el-form-item>
          <el-form-item label="章节讲义" prop="attach_id">
            <ApeUploader :limit="1" :isImage="false" :allowSize="1024*1024*500" :allowTypeList="handoutTypeList" @handleUploadSuccess="handleUploaChapterHandoutSuccess" @handleUploadRemove="handleUploadChapterHandoutRemove" :upload-file-list="uploadChapterHandoutFileList"></ApeUploader>
          </el-form-item>
        </el-form>        
      </template>
    </ModalDialog>
    <ApeDrawer :drawerData="drawerData"  @drawerClose="drawerClose" @drawerConfirm="drawerConfirm">
      <template slot="ape-drawer">
        <el-form :model="videoFormData" :rules="videoRules" ref="videoForm" label-position="right" label-width="96px">
          <el-row>
            <el-col :span="22">
              <el-form-item label="标题" prop="title">
                <el-input v-model="videoFormData.title"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="简介" prop="intro">
                <el-input type="textarea" :rows="6" v-model="videoFormData.intro"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="视频" prop="aliyun_video_id" ref="aliyunVodUload">
                <ApeAliyunVodUpload :is-start-upload="isStartUpload" :upload-file-list="uploadVodList" @handleUploadChange="handleVodUploadChange" @handleUploadRemove="handleVodUploadRemove" @handleUploadSuccess="handleVodUploadSuccess"></ApeAliyunVodUpload>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="试看规则" prop="is_try">
                <el-switch
                  v-model="videoFormData.is_try"
                  active-color="#1890ff"
                  :active-value="1"
                  :inactive-value="0">
                </el-switch>
                <el-tooltip content="默认0秒，完整试看！" placement="top" v-if="videoFormData.is_try == 1">
                  <span class="try-time">
                    <span>可试看：</span>
                    <el-input-number v-model="videoFormData.try_time" size="small" controls-position="right" :step="60" :min="0" :max="7200"></el-input-number>
                    <span> 秒！</span>
                  </span>
                </el-tooltip>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="SEO标题" prop="seo_title">
                <el-input v-model="videoFormData.seo_title"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="SEO关键词" prop="seo_keywords">
                <el-input v-model="videoFormData.seo_keywords"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="SEO描述" prop="seo_description">
                <el-input type="textarea" :rows="4" v-model="videoFormData.seo_description"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>     
      </template>
    </ApeDrawer>
    <div class="ape-aliyun-player-mask" :class="{'is-video-preview':isVideoPreview}" v-if="isVideoPreview">
      <h2 class="header-title">视频预览({{previewVideoTitle}})</h2>
      <el-button class="close-button" type="danger" size="mini" icon="iconfont icon-close" circle @click="closeVideoPreview"></el-button>
      <ApeAliyunPlayer ref="apeAliyunPlayer" :auto-play="true" :width="'640px'" :height="'480px'"></ApeAliyunPlayer>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import ApeDrawer from '@/components/ApeDrawer'
import ModalDialog from '@/components/ModalDialog'
import ApeUploader from '@/components/ApeUploader'
import ApeAliyunVodUpload from '@/components/ApeAliyunVodUpload'
import ApeAliyunPlayer from '@/components/ApeAliyunPlayer'
import ApeButton from '@/components/ApeButton'
import { mapGetters } from 'vuex'

export default {
  components: {
    ApeAliyunVodUpload,
    ApeAliyunPlayer,
    ApeDrawer,
    ModalDialog,
    ApeUploader,
    ApeButton
  },
  props: {
    // 课程id
    courseId: {
      type: String,
      default() {
        return '0'
      }
    },
  },
  // 定义属性
  data() {
    return {
      // 章节讲义上传列表
      uploadChapterHandoutFileList:[],
      // 讲义支持上传类型
      handoutTypeList:['application/pdf','application/zip','application/rar'],
      // 视频章节list
      videoChapterList:[],
      // 视频章节信息，弹窗数据
      dialogData:{
        visible: false,
        title: '',
        width: '30%',
        loading: true,
        modal: true
      },
      // 视频章节信息表单结构
      videoChapterFormData:{},
      // 视频章节规则
      videoChapterRules: {
        title: [
          {required: true, message: '输入章节标题', trigger: 'blur' },
        ],
      },
      // 视频信息,抽屉数据
      drawerData: {
        visible: false,
        loading: true,
        loading_text: '玩命加载中……',
        // direction: 'right',
        title: '视频添加',
        width_height: '640px',
        // mask: false,
        // close_name: '关 闭',
        // confirm_name: '打 印',
      },
      // 视频上传控制
      isStartUpload:false,
      // 是否选取了视频文件，既要不要执行上传
      isChangeVideo:false,
      // 视频信息表单结构
      videoFormData:{},
      // 已上传的视频列表，虽然只允许上传一个
      uploadVodList:[],
      // 视频规则
      videoRules: {
        title: [
          {required: true, message: '输入视频标题', trigger: 'blur' },
        ],
        aliyun_video_id: [
          {required: true, message: '选择视频', trigger: 'blur', validator:this.apeAliyunVodUploaderVerify},
        ],
      },
      // 是否视频预览
      isVideoPreview: false,
      // 预览视频的title
      previewVideoTitle: '',
      // 轮询你请求视频列表
      videoInterval: null,
    }
  },
  computed: {
    ...mapGetters(['userPermissions'])
  },
  // 方法集合
  methods: {
    // 添加视频章
    addVideoChapter() {
      this.dialogData.visible = true
      this.dialogData.title = '添加章节'
      this.videoChapterFormData.course_id = this.courseId
      this.uploadChapterHandoutFileList = []
      this.dialogData.loading = false
    },
    // 章节讲义上传成功回调
    handleUploaChapterHandoutSuccess(file, fileList) {
      this.videoChapterFormData.attach_id = file.id
      this.uploadChapterHandoutFileList = fileList
    },
    // 章节讲义删除回调
    handleUploadChapterHandoutRemove(file, fileList) {
      this.videoChapterFormData.attach_id = 0
      this.uploadChapterHandoutFileList = fileList
    },
    // 处理模态框，确定事件
    dialogConfirm() {
      // 调用组件的数据验证方法
      this.$refs['videoChapterForm'].validate((valid) => {
        if (valid) {
          this.videoChapterFormSubmit()
        } else {
          this.$notify.error('数据验证失败，请检查必填项数据！')
        }
      })
    },
    // 处理模态框，关闭事件
    dialogClose() {
      this.initVideoChapterFormData()
    },
    // 初始化视频章节数据
    initVideoChapterFormData() {
      // 初始化form表单
      this.$nextTick(() => {
        this.dialogData.visible = false
        this.dialogData.loading = true
        this.videoChapterFormData = {}
        this.$refs['videoChapterForm'].resetFields()
      })
    },
    // 初始化视频章节list
    async initVideoChapterList(type) {
      if (!type) {
        this.$store.commit('changeLoadingStatus',true)
      }
      let {list}= await this.$api.getCourseVideoList(this.courseId)
      this.videoChapterList=list
      if (!type) {
        this.$nextTick(() => {
          this.$store.commit('changeLoadingStatus',false)
        }) 
      }
    },
    // 视频章节信息提交，请求接口
    async videoChapterFormSubmit() {
      let id = await this.$api.saveCourseVideoChapter(this.videoChapterFormData)
      if (id) {
        this.initVideoChapterList()
      }
      this.initVideoChapterFormData()
      this.$notify.success('章节信息保存成功!')
    },

    // 编辑视频章节
    async editVideoChapter(id) {
      this.dialogData.loading_text = '玩命加载中……'
      this.dialogData.visible = true
      this.dialogData.title = '编辑章节'
      let {info} = await this.$api.getCourseVideoChapterInfo(id)
      this.videoChapterFormData = info
      if (info.attach_id) {
        this.uploadChapterHandoutFileList = [{id:info.attach_info.id,name:info.attach_info.title,url:info.attach_info.full_path}]
      } else {
        this.uploadChapterHandoutFileList = []
      }
      this.dialogData.loading = false
    },
    // 删除视频章节
    async deleteVideoChapter(data) {
      let info = await this.$api.deleteCourseVideoChapterInfo(data)
      if (info == 'ok') {
        this.$nextTick(() => {
          this.initVideoChapterList()
        })
      } else {
        this.$notify.error(info)
      }
    },
    // 处理抽屉关闭
    drawerClose() {
      this.initVideoFormData()
    },
    // 处理抽屉确认
    async drawerConfirm() {
      // 调用组件的数据验证方法
      this.$refs['videoForm'].validate((valid) => {
        if (valid) {
          if (this.isChangeVideo) {
            this.isStartUpload = true
          } else {
            this.videoFormSubmit()
          }
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
          this.$nextTick(() => {
            this.isStartUpload = false
          })
        }
      })
    },
    // 处理视频文件选择回调
    handleVodUploadChange(fileInfo) {
      this.videoFormData.aliyun_video_id = fileInfo.video_id
      this.videoFormData.filename = fileInfo.filename
      this.isChangeVideo = true
      this.$refs['videoForm'].clearValidate(['aliyun_video_id'])
    },
    // 处理视频删除回调
    handleVodUploadRemove() {
      this.videoFormData.aliyun_video_id = ''
      this.videoFormData.filename = ''      
    },
    // 处理视频上传成功回调
    handleVodUploadSuccess() {
      this.videoFormData.status = 0
      this.videoFormSubmit()
    },
    // 视频上传自定义验证
    apeAliyunVodUploaderVerify(rule, value, callback) {
      if (rule.required && !this.videoFormData.aliyun_video_id) {
        callback(new Error(rule.message))
      }
      callback()
    },
    // 视频信息提交，请求接口
    async videoFormSubmit(data) {
      let saveData = data?data:this.videoFormData
      let id = await this.$api.saveCourseVideo(saveData)
      if (id && !data) {
        this.initVideoChapterList()
      }
      this.initVideoFormData()
      this.$notify.success('视频信息保存成功!')
    },
    // 初始化视频数据
    initVideoFormData() {
      // 初始化form表单
      this.$nextTick(() => {
        this.drawerData.visible = false
        this.drawerData.loading = true
        this.videoFormData = {}
        this.isStartUpload = false
        this.isChangeVideo = false
        this.$refs['videoForm'].resetFields()
      })
    },
    // 添加视频
    addVideo(chapterId) {
      this.drawerData.loading_text = '玩命加载中……'
      this.drawerData.visible = true
      this.drawerData.title = '添加视频'
      this.videoFormData.course_id = this.courseId
      this.videoFormData.chapter_id = chapterId
      this.uploadVodList =[]
      this.$nextTick(() => {
        this.drawerData.loading = false
      })
    },
    // 编辑视频
    async editVideo(id) {
      this.drawerData.loading_text = '玩命加载中……'
      this.drawerData.visible = true
      this.drawerData.title = '编辑视频'
      let {info} = await this.$api.getCourseVideoInfo(id)
      this.videoFormData = info
      this.uploadVodList =[{name:info.filename}]
      this.drawerData.loading = false
    },
    // 视频预览
    async videoPreview(data) {
      this.isVideoPreview = true
      this.previewVideoTitle = data.title
      let previewInfo = await this.$api.getCourseVideoPreview(data.aliyun_video_id);
      this.$refs.apeAliyunPlayer.replayByVidAndPlayAuth(previewInfo['auth_info']['VideoMeta']['VideoId'],previewInfo['auth_info']['PlayAuth'])
    },
    // 关闭视频预览
    closeVideoPreview() {
      this.isVideoPreview = false
      this.$refs.apeAliyunPlayer.pause()
    },
    // 删除视频章节
    async deleteVideo(data) {
      let info = await this.$api.deleteCourseVideoInfo(data)
      if (info == 'ok') {
        this.$nextTick(() => {
          this.initVideoChapterList()
        })
      } else {
        this.$notify.error(info)
      }
    },
    // 判断是否可以被托转
    handleAllowDrop() {
      return true
    },
    // 处理节点拖拽完成，前端效果结束且成功后执行，不使用组件回调参数，功能判断放到后端
    async handleNodeDrop() {
      let info = await this.$api.orderCourseVideoChapter(this.videoChapterList)
      if (info == 'ok') {
        this.$nextTick(() => {
          this.initVideoChapterList()
        })
        this.$notify.success('排序成功！')
      } else {
        this.initVideoChapterList()
        this.$notify.error(info)
      } 
    },
    // 是否试看
    changeTry(data){
      this.videoFormSubmit({'id':data.id,'is_try':data.is_try,'try_time':data.try_time})
    },
    // 试看时间
    changeTryTime(data) {
      this.videoFormSubmit({'id':data.id,'is_try':data.is_try,'try_time':data.try_time})
    }
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.initVideoChapterList()
    this.videoInterval = setInterval(() => {return this.initVideoChapterList(true)},30000)
  },
  // 生命周期 - 销毁之前
  beforeDestroy() {
    clearInterval(this.videoInterval);
  }
}
</script>

<style lang='stylus'>
  .tab-pane-body-video
    padding 16px
    .body-header
      min-height 48px
      border-bottom 1px dashed #e8e8e8
    .body-content
      margin 16px 16px 0px 16px
    .el-tree i
      margin-right 0px !important
    .el-tree-node__expand-icon
      margin-left -8px
      padding 4px
      font-size 20px
      color #1890ff
    .el-tree-node__children .el-tree-node__expand-icon
      margin 0px
      width 0px
      height 0px
      padding 0px !important
      overflow hidden
  .video-tree-node
    line-height 40px
    width 100%
    span
      margin-right 8px
    .el-button i
      margin-right 0px
    .el-button--mini
      padding 7px 8px
    .chapter-node
      font-size 14px !important
      .right
        float right
        span
          margin-right 0px
    .video-node
      font-size 12px
      .quick-actions
        width 400px
        display inline-block
        float right
        font-size 14px
        font-weight bold
      .right
        float right
        span
          margin-right 0px
      .video-identify
        border-radius 4px
        padding 1px 5px
        border 1px solid #c2c2c2
  .view-video
    background-color #5cdbd3
    border-color #5cdbd3
    color #fff
    &:hover,&:focus
      background #87e8de;
      border-color #87e8de
      color #fff
  .ape-aliyun-player-mask
    top 0
    left 0
    position fixed
    width 100%
    height 0
    z-index 99999
    display none
    transition opacity .3s linear,height 0s ease .3s
    .icon-close
      margin-right 0px !important
  .ape-aliyun-player-mask.is-video-preview
    height 100%
    display block
    background-color rgba(0,0,0,0.85)
    transition opacity ease-in-out 0.38s, visibility ease-in-out 0.38s
    .header-title
      color #ffffff
      text-align center
      margin-top 48px
      margin-bottom 24px
    .close-button
      position absolute
      top 32px
      right 120px
  .try-time
    margin-left 8px
    .el-input-number--small 
      width 80px
    .el-input-number.is-controls-right .el-input__inner
      padding-left 8px
      padding-right 32px
    .el-input-number--small .el-input-number__increase,.el-input-number--small .el-input-number__decrease
      width 24px
      margin 0px
    
</style>